import React, { useEffect } from "react"; // eslint-disable-line
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, Redirect } from "react-router-dom";
import { translate } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _actions from "../../actions";
import constants from "../../constants";
import DropMenuUnity from "../../components/common/DropMenuUnity";
import CaptionTooltip from "../../components/common/CaptionTooltip";
import i18n from "../../i18n";
import { createsession } from "../../token/refreshToken";
import { setToken, setsessionId } from "../../token/setToken";
import appStateProvider from "../../utilities/appStateProvider";
import {  ENVIRONMENT, APP_BUILDER_MODULE_ID } from "../../utilities/constants";
import apiClient from "../../config/axiosConfig";
class AppbuilderHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggingout: false,
      dropOpen: false,
      viewSwitcher: false,
      activeEnvironment: ENVIRONMENT.AMPLIFY,
    };
    this.logout = this.logout.bind(this);
    this.toggleDrop = this.toggleDrop.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    setsessionId();
    this.handleAppSwitcher = this.handleAppSwitcher.bind(this);
    this.loadAppSelector = this.loadAppSelector.bind(this);
    this.appSwitcher = React.createRef();
  }

  loadAppSelector = (appSwitcher) => {
    let activeEnvironment = ENVIRONMENT.AMPLIFY;
    const appState = appStateProvider();
    const unityOrgId = appState.getUnityOrgId();
    if (
      appSwitcher &&
      appSwitcher.current !== null &&
      appSwitcher.current.childElementCount === 0 &&
      unityOrgId
    ) {
      let scriptTag = document.createElement("script");
      scriptTag.async = true;
      scriptTag.dataset.uuid = unityOrgId;
      scriptTag.dataset.currentOrgName = appState.getOrgName();
      scriptTag.dataset.fixed = "true";
      scriptTag.dataset.haveRequiredFonts = "true";

      let switcherPath = "";
      if(this.props.flags.results?.orgSwitcher){
        // Org Switcher 
        switcherPath = "/orgSwitcher/orgSwitcher.js";
        scriptTag.id = "orgSwitcherScript";
        scriptTag.dataset.selected = APP_BUILDER_MODULE_ID;
      } else {
        // App Switcher
        switcherPath = "/appSwitcher/switcher.js";
        scriptTag.id = "appSwitcherScript";
        scriptTag.dataset.selected = appState.getUnityAppModule();
      }

      if (window.location.hostname.includes(ENVIRONMENT.MY_PARISH_SOFT)) {
        // MY PARISH SOFT BASE URL
        scriptTag.src = `${window.MY_PARISH_SOFT_URL}${switcherPath}`;
        activeEnvironment = ENVIRONMENT.MY_PARISH_SOFT;
      } else if (window.location.hostname.includes(ENVIRONMENT.AMPLIFY)) {
        // AMPLIFY BASE URL
        scriptTag.src = `${window.UNITY_URL}${switcherPath}`;
        activeEnvironment = ENVIRONMENT.AMPLIFY;
      } else if (window.location.hostname.includes("localhost")) {
        // LOCAL HOST TESTING
        scriptTag.src = `${window.UNITY_URL}${switcherPath}`;
        activeEnvironment = ENVIRONMENT.LOCAL;
      } else {
        console.error("Something went wrong with Org switcher base url.");
      }
      appSwitcher.current.appendChild(scriptTag);
      this.setState({
        activeEnvironment,
      });
    }
  }

  componentDidMount() {
    if (!localStorage.getItem("SessionId")) {
      // here, we use the token to create a session.  I don't see the need to clear the stored "AuthToken" after createsession() call.
      createsession();
      //  need to clear the current token to avoid use of the expired token.
      //localStorage.setItem("AuthToken", "");
      setToken();
    }
    document.addEventListener("mousedown", this.handleClickOutside);
    let self = this;
    function getProfile() {
      if (localStorage.getItem("UnityOrgId")) {
        self.props.actions.getCurrentProfile(self.props.profiles);
      } else {
        setTimeout(getProfile, 1000);
      }
    }
    setTimeout(getProfile, 1000);

    this.toggleMobileMenuState = this.toggleMobileMenuState.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.loggingout &&
      this.props.router.location.pathname === "/logged-out"
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ loggingout: false });
    }
    if (
      this.props.profiles?.data?.organizationId &&
      !prevProps.profiles?.data?.organizationId
    ) {
      if (
        window.RESTRICTED_ORGS.includes(this.props.profiles.data.organizationId)
      ) {
        this.props.actions.addAlert({
          message: i18n.t("banners.appleStoreOrg"),
          type: "banner",
          id: "apple",
          global: true,
          dismissable: true,
        });
      }
    }

    if(this.props.flags.results !== prevProps.flags.results){
      this.loadAppSelector(this.appSwitcher)
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ dropOpen: false });
    }
  }

  handleAppSwitcher() {
    this.setState((state) => ({
      //eslint-disable-line
      viewSwitcher: !state.viewSwitcher,
    }));
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  getInitials = (name) => {
    if (name) {
      // eslint-disable-next-line no-param-reassign
      name = name.trim();
      const spaceLoc = name.lastIndexOf(" ");
      if (spaceLoc > 0) {
        const firstName = name.substring(0, spaceLoc);
        const lastName = name.substring(spaceLoc + 1, name.length);
        return `${firstName[0]}${lastName[0]}`;
      }
      return name[0];
    }
    return "";
  };

  toggleDrop() {
    this.setState((prevState) => {
      return { dropOpen: !prevState.dropOpen };
    });
  }

  logout() {
    this.toggleDrop();
    
    apiClient.get('/logout', {
      headers: {
        'X-Session-Id': sessionStorage.getItem("SessionId")
      }
    })
      .then((response) => {
        localStorage.clear();
        this.props.actions.logout();
        this.setState({ loggingout: true });
        window.location = response.data;
      })
      .catch((error) => {
        console.error('Logout API call failed:', error);
      });
  }

  toggleMobileMenuState() {
    this.props.actions.toggleMobileMenuShown(this.props.sidecar.showMobile);
  }

  render() {
    if (this.state.loggingout) {
      return <Redirect to="/logged-out" />;
    }
    const { t } = this.props;
    const initials = this.props.profiles?.data
      ? this.getInitials(this.props.profiles.data.name)
      : "";
    const resellerConstant = this.props.profiles?.data
      ? constants.HelpResellerIds.find((mt) => {
          return mt.ResellerName === this.props.profiles.data.resellerName;
        })
      : "";
    const reseller =
      this.props.profiles?.data?.resellerName && resellerConstant
        ? resellerConstant.ResellerCode
        : "";

    return (
      <div className="top-nav-wrapper-unity">
        {this.props.router?.location?.pathname?.indexOf("/projects/") === 0 &&
          this.props.router?.location?.pathname?.length > 20 && (
            // eslint-disable-next-line
            <a
              onClick={this.toggleMobileMenuState}
              className="mobile-nav-launcher hidden"
            >
              <span className="sr-only">
                {t("header-tooltips.toggle-navigation")}
              </span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </a>
          )}
        <div className="branding-wrap" data-qa="header-bar">
          <div
            className="inner-branding-wrap-container"
            style={{ marginLeft: "-20px", height: "65px" }}
          >
            <div className="app-switcher-container">
              <div
                id="placeholderElement"
                ref={this.appSwitcher}
                style={{ height: "100%" }}
              />
            </div>
          </div>
        </div>
        {this.props.profiles?.data?.name && (
          <nav className="top-nav">
            <ul>
              <li
                id="tn-messages-unity"
                className="tn-messages"
                data-qa="messages-menu-item"
              >
                <div>
                  <CaptionTooltip
                    tooltipText={t("header-tooltips.messages")}
                    className="tooltip-header"
                  >
                    <Link
                      aria-label={t("header-tooltips.messages")}
                      className="branding-link-unity-messages"
                      to="/messages"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20px"
                        height="18px"
                        viewBox="0 0 512 512"
                        fill="#ffffff"
                      >
                        <path d="M490.3 40.4C512.2 62.27 512.2 97.73 490.3 119.6L460.3 149.7L362.3 51.72L392.4 21.66C414.3-.2135 449.7-.2135 471.6 21.66L490.3 40.4zM172.4 241.7L339.7 74.34L437.7 172.3L270.3 339.6C264.2 345.8 256.7 350.4 248.4 353.2L159.6 382.8C150.1 385.6 141.5 383.4 135 376.1C128.6 370.5 126.4 361 129.2 352.4L158.8 263.6C161.6 255.3 166.2 247.8 172.4 241.7V241.7zM192 63.1C209.7 63.1 224 78.33 224 95.1C224 113.7 209.7 127.1 192 127.1H96C78.33 127.1 64 142.3 64 159.1V416C64 433.7 78.33 448 96 448H352C369.7 448 384 433.7 384 416V319.1C384 302.3 398.3 287.1 416 287.1C433.7 287.1 448 302.3 448 319.1V416C448 469 405 512 352 512H96C42.98 512 0 469 0 416V159.1C0 106.1 42.98 63.1 96 63.1H192z" />
                      </svg>
                    </Link>
                  </CaptionTooltip>
                </div>
              </li>
              <li
                id="tn-help-unity"
                className="tn-help"
                data-qa="help-menu-item"
              >
                <CaptionTooltip tooltipText={t("header-tooltips.help")}>
                  {/* eslint-disable-next-line */}
                  <Link
                    aria-label={t("header-tooltips.help")}
                    className="ab-help-link"
                    to={{
                      pathname:
                        this.state.activeEnvironment === ENVIRONMENT.AMPLIFY
                          ? "https://mbmobileapp.zendesk.com/"
                          : "https://support.parishsoft.com/hc/en-us",
                    }}
                    target="_blank"
                  >
                    <FontAwesomeIcon
                      icon={["fas", "question-circle"]}
                      color="#ffffff"
                    />
                  </Link>
                </CaptionTooltip>
              </li>
              <li
                id="tn-promote-unity"
                className="tn-promote"
                data-qa="promote-menu-item"
              >
                <CaptionTooltip tooltipText={t("header-tooltips.promote")}>
                  <Link
                    aria-label={t("header-tooltips.promote")}
                    className="branding-link-unity-promote"
                    to="/promote"
                  >
                    {/* <Promote /> */}
                    <FontAwesomeIcon
                      icon={["fas", "megaphone"]}
                      color="#ffffff"
                    />
                  </Link>
                </CaptionTooltip>
              </li>
              {this.props.flags.results?.analytics && (
                <li
                  id="tn-analytics-unity"
                  className="tn-analytics"
                  data-qa="analytics-menu-item"
                >
                  <CaptionTooltip tooltipText={t("header-tooltips.analytics")}>
                    <Link
                      aria-label={t("header-tooltips.analytics")}
                      className="branding-link-unity-analytics"
                      to="/analytics"
                    >
                      {/* <Analytics /> */}
                      <FontAwesomeIcon
                        icon={["fas", "chart-line"]}
                        color="#ffffff"
                      />
                    </Link>
                  </CaptionTooltip>
                </li>
              )}
              <li
                id="tn-projects"
                className="tn-projects"
                data-qa="projects-menu-item"
              >
                <CaptionTooltip
                  tooltipText={t("header-tooltips.projects")}
                  place="top"
                >
                  <Link
                    aria-label={t("header-tooltips.projects")}
                    className="branding-link projects"
                    to="/"
                  >
                    <FontAwesomeIcon icon={["fas", "folder"]} color="#ffffff" />
                  </Link>
                </CaptionTooltip>
              </li>
              <li
                id="tn-profile"
                data-qa="profile-menu-button"
                ref={this.setWrapperRef}
                className={`tn-profile ${
                  initials.length > 0 ? "initials" : "none"
                }`}
              >
                {/* eslint-disable-next-line react/button-has-type */}
                <button onClick={this.toggleDrop}>{initials}</button>
                {initials.length > 0 ? (
                  <DropMenuUnity
                    logout={this.logout}
                    Visible={this.state.dropOpen}
                  />
                ) : (
                  ""
                )}
              </li>
            </ul>
          </nav>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(_actions, dispatch),
  };
};

export default translate("translations")(
  connect(mapStateToProps, mapDispatchToProps)(AppbuilderHeader)
);
